import { Injectable } from '@angular/core';
import { Effect, ofType, Actions, createEffect } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IBeneficiario, IDeleteBeneficiarioResponse, ILoadPadronResponse, IUpdateBeneficiario } from '../../interfaces/beneficiarios.interface';
import {
  CreateBeneficiario, CreateBeneficiarioSuccess, DeleteBeneficiario, DeleteBeneficiarioSuccess,
  GetBeneficiarios, GetBeneficiariosSuccess, GetEstudioBeneficiario, GetEstudioBeneficiarioSuccess,
  LoadPadrones, LoadPadronesSuccess,
  UpdateBeneficiario, UpdateBeneficiarioSuccess, UpdateEstudioBeneficiario, UpdateEstudioBeneficiarioSuccess
} from '../actions/beneficiarios.actions';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Injectable()
export class BeneficiariosEffects {
  getBeneficiarios$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetBeneficiarios),
      switchMap(() =>
        this.apiService.getBeneficiarios().pipe(
          map((beneficiarios: IBeneficiario[]) => GetBeneficiariosSuccess({ beneficiarios }))
        )
      )
    )
  );

  createBeneficiario$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CreateBeneficiario),
      switchMap(payload =>
        this.apiService.createBeneficiario(payload.beneficiario).pipe(
          map((beneficiario: IBeneficiario) => CreateBeneficiarioSuccess({ beneficiario }))
        )
      )
    )
  );

  deleteBeneficiario$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeleteBeneficiario),
      switchMap(payload =>
        this.apiService.deleteBeneficiario(payload.id).pipe(
          map((beneficiario: IDeleteBeneficiarioResponse) => DeleteBeneficiarioSuccess({ beneficiario }))
        )
      )
    )
  );

  updateBeneficiario$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateBeneficiario),
      switchMap(payload =>
        this.apiService.updateBeneficiario(payload.id, payload.beneficiario).pipe(
          map((beneficiario: IUpdateBeneficiario) => UpdateBeneficiarioSuccess({ beneficiario }))
        )
      )
    )
  );

  getEstudioBeneficiario$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GetEstudioBeneficiario),
      switchMap(payload =>
        this.apiService.getEstudioBeneficiario(payload.id).pipe(
          map((estudio: object) => GetEstudioBeneficiarioSuccess({ estudio }))
        )
      )
    )
  );

  updateEstudioBeneficiario$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UpdateEstudioBeneficiario),
      switchMap(payload =>
        this.apiService.updateEstudioBeneficiario(payload.id, payload.estudio).pipe(
          map((estudio: object) => UpdateEstudioBeneficiarioSuccess({ estudio }))
        )
      )
    )
  );

  loadPadrones$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadPadrones),
      switchMap(payload =>
        this.apiService.loadPadron(payload.beneficiarios).pipe(
          map((beneficiarios: ILoadPadronResponse) => LoadPadronesSuccess({ beneficiarios }))
        )
      )
    )
  );

  constructor(
    private apiService: ApiService,
    private actions$: Actions,
    private authenticationService: AuthenticationService,
    private store: Store<IAppState>
  ) { }
}
